import React from "react";

export default function IndexSectionFeatures2() {
  return (
    <React.Fragment>
      <>
        <section className="relative py-20 overflow-hidden" id="features">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center">
              <span className="inline-block py-1 px-3 mb-4 text-xs font-semibold text-orange-900 bg-orange-50 rounded-full">
                FEATURES
              </span>
              <h1 className="font-heading text-5xl xs:text-6xl md:text-7xl font-bold text-gray-900 mb-24">
                <span>必要なのはスマホだけ</span>
              </h1>
            </div>
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-wrap -mx-4 items-center">
                <div className="w-full lg:w-2/5 xl:w-auto px-4 lg:pb-10 mb-16 lg:mb-0">
                  <div className="mx-auto max-w-sm">
                    <div className="flex items-center pb-12 mb-12 border-b border-gray-100">
                      <div className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-blue-100 rounded-full">
                        <img
                          src="saturn-assets/images/features/icon-element.svg"
                          alt
                        />
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold">シンプル</h3>
                        <span className="text-sm text-gray-400">
                          スマートフォン1台で利用いただけます
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center pb-12 mb-12 border-b border-gray-100">
                      <div className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-orange-100 rounded-full">
                        <img
                          src="saturn-assets/images/features/icon-hierarchy.svg"
                          alt
                        />
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold">定額制</h3>
                        <span className="text-sm text-gray-400">
                          どんなに QR を読み取っても金額は変わりません
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <div className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-gray-300 rounded-full">
                        <img
                          src="saturn-assets/images/features/icon-school-bag.svg"
                          alt
                        />
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold">拡張性</h3>
                        <span className="text-sm text-gray-400">
                          私たちはお客様の要望に柔軟に応えられます
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full lg:w-1/5 xl:w-auto mx-auto px-4 xl:-mr-10 mb-16 lg:mb-0">
                  <img
                    className="block h-80 md:h-100 lg:h-auto xl:h-150 mx-auto"
                    src="saturn-assets/images/features/phone-picture.png"
                    alt
                  />
                </div>
                <div className="w-full lg:w-2/5 xl:w-auto px-4 lg:pb-10">
                  <div className="mx-auto max-w-sm">
                    <div className="flex items-center pb-12 mb-12 border-b border-gray-100">
                      <div className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-red-200 rounded-full">
                        <img
                          src="saturn-assets/images/features/icon-robot.svg"
                          alt
                        />
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold">セキュリティ</h3>
                        <span className="text-sm text-gray-400">
                          全ては暗号化されています
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center pb-12 mb-12 border-b border-gray-100">
                      <div className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-yellow-200 rounded-full">
                        <img
                          src="saturn-assets/images/features/icon-cam.svg"
                          alt
                        />
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold">
                          場所を問わず利用可能
                        </h3>
                        <span className="text-sm text-gray-400">
                          利用する場所が変わっても利用できます
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center">
                      <div className="flex flex-shrink-0 w-15 h-15 mr-6 items-center justify-center bg-green-200 rounded-full">
                        <img
                          src="saturn-assets/images/features/icon-flask.svg"
                          alt
                        />
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold">サポート体制</h3>
                        <span className="text-sm text-gray-400">
                          こちらから簡単にお問い合わせできます
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
}
